import React from "react";
import { FormTextInput } from "@jsq/ds/forms";
import { PayeeDetailsBaseProps } from "./types";

export const PayeeDetailsBase = ({ payeeNameLabel }: PayeeDetailsBaseProps) => {
  return (
    <FormTextInput
      placeholder={"Business name or legal full name"}
      name={"payeeName"}
      label={payeeNameLabel}
      isFullWidth
    />
  );
};
